<template>
    <div class="information">
        <div id="nav">
            <div class="bgc">
            </div>
        </div>
        <div class="row">
            <el-form ref="selectList" class="clear" label-position="right" label-width="45%" :model="selectList"
                :rules="rules" style="width: 93%;">
                <el-row>
                    <el-col>
                        <el-form-item label="招标项目名称:" prop="tenProjName" :rules="rules.tenProjName">
                            <el-input v-model="selectList.tenProjName" clearable placeholder="请输入招标项目名称">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="项目编号:" prop="tenProjCode" :rules="rules.tenProjCode">
                            <el-input v-model="selectList.tenProjCode" clearable placeholder="请输入项目编号">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="招标人名称:" prop="tender" :rules="rules.tender">
                            <el-input v-model="selectList.tender" clearable placeholder="请输入招标人名称">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="招标纳税人识别号:" prop="">
                            <el-input v-model="selectList.tenderTin" clearable placeholder="请输入招标纳税人识别号">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="投标人名称:" prop="bidder" :rules="rules.bidder">
                            <el-input v-model="selectList.bidder" clearable placeholder="请输入投标人名称">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="投标纳税人识别号:" prop="bidderTin" :rules="rules.bidderTin">
                            <el-input v-model="selectList.bidderTin" clearable placeholder="请输入投标纳税人识别号">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="开标时间:" prop="invoiceDate" :rules="rules.invoiceDate">
                            <el-date-picker style="width:100%" v-model="selectList.invoiceDate"
                                value-format="yyyy-MM-dd" type="date" placeholder="请选择开标时间" popper-class="width">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="标书有效天数:" prop="effectDay" :rules="rules.effectDay" v-number-input>
                            <el-input v-model="selectList.effectDay" clearable placeholder="请输入标书有效天数" @focus="biaoshu">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- <el-row>
                    <el-col>
                        <el-form-item label="保险期限止:" prop="endDate" :rules="rules.endDate">
                            <el-date-picker style="width:100%" v-model="selectList.endDate" value-format="yyyy-MM-dd"
                                type="date" placeholder="请选择保险期限止" popper-class="width">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row> -->
                <el-row>
                    <el-col>
                        <el-form-item label="保证金金额:" prop="marginAmount" :rules="rules.marginAmount">
                            <el-input v-model="selectList.marginAmount" clearable placeholder="请输入保证金金额" v-number-input>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="投标经办人姓名:" prop="bidderContact" :rules="rules.bidderContact">
                            <el-input v-model="selectList.bidderContact" clearable placeholder="请输入投标经办人姓名">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="投标经办人电话:" prop="bidderTel" :rules="rules.bidderTel">
                            <el-input v-model="selectList.bidderTel" clearable placeholder="请输入投标经办人电话">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="投标经办人邮箱:" prop="bidderMail" :rules="rules.bidderMail">
                            <el-input v-model="selectList.bidderMail" clearable placeholder="请输入投标经办人邮箱" @focus="tishi">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="footer-mian-fixed">
            <div class="left">
                <div style="width: 100%;display: flex;">
                    <b style="font-size: 2.5rem;color:#EE7800;margin: 1rem 0 0 0;">保费:</b>
                    <span>{{selectList.premium}}元</span>
                </div>
            </div>
            <div class="right">
                <span @click="nowtoubao">
                    立即提交
                    <!-- <router-link to="/paymentguide" style="color: white;text-decoration: none;" @click="nowtoubao">立即购买</router-link> -->
                </span>
            </div>
        </div>
    </div>
</template>
<script>
    import { get, post } from '@/request/http'
    import axios from "axios";
    import $ from "jquery";
    import { Base64 } from 'js-base64'
    import {
        number_format
    } from "@/filters";
    import {
        validateEmail,
        validatePhone,
    } from "@/request/validate";
    export default {
        data() {
            const checkEmail = (rule, value, callback) => {
                if (validateEmail(value)) {
                    callback();
                } else {
                    callback(rule.message);
                }
            };
            const checkPhone = (rule, value, callback) => {
                if (!value || validatePhone(value)) {
                    callback();
                } else {
                    callback(rule.message);
                }
            };
            return {
                selectList: {
                    tenProjName: null,
                    tenProjCode: null,
                    tender: null,
                    tenderTin: null,
                    bidder: null,
                    bidderTin: null,
                    marginAmount: null,
                    invoiceDate: null,
                    effectDay: null,
                    bidderContact: null,
                    bidderTel: null,
                    bidderMail: null,
                    premium: 0,
                    id: null,
                },
                rules: {
                    tenProjName: [
                        {
                            required: true,
                            message: '请输入招标项目编码',
                            trigger: ['change', 'blur']
                        }
                    ],
                    tenProjCode: [
                        {
                            required: true,
                            trigger: ['change', 'blur'],
                            message: "请输入招标项目编码",
                        },
                    ],
                    tender: [
                        {
                            required: true,
                            trigger: ["change"],
                            message: "请输入招标人名称",
                        },
                    ],
                    // endDate: [
                    //     {
                    //         required: true,
                    //         trigger: ["change"],
                    //         message: "请输入保险期限止",
                    //     },
                    // ],
                    bidder: [
                        {
                            required: true,
                            trigger: ["change"],
                            message: "请输入投标人姓名",
                        },
                    ],
                    bidderTin: [
                        {
                            required: true,
                            trigger: ["change"],
                            message: "请输入投标人投标纳税人识别号",
                        },
                    ],
                    marginAmount: [
                        {
                            required: true,
                            trigger: ["change"],
                            message: "请输入保证金额",
                        },
                    ],
                    invoiceDate: [
                        {
                            required: true,
                            trigger: ["change"],
                            message: "请输入开标时间",
                        },
                    ],
                    effectDay: [
                        {
                            required: true,
                            trigger: ["change"],
                            message: "请输入投标文件有效期",
                        },
                    ],
                    bidderContact: [
                        {
                            required: true,
                            trigger: ["change"],
                            message: "请输入投标人经办人姓名",
                        },
                    ],
                    bidderTel: [
                        {
                            required: true,
                            trigger: ["change"],
                            message: "请输入投标人经办人电话",
                        },
                        {
                            validator: checkPhone,
                            trigger: ["change"],
                            message: "电话输入不合法",
                        },
                    ],
                    bidderMail: [
                        {
                            required: true,
                            trigger: ["change"],
                            message: "请输入投标人经办人邮箱",
                        },
                        {
                            validator: checkEmail,
                            trigger: ["change"],
                            message: "邮箱地址输入不合法",
                        },
                    ],
                },
                lock: true,
                customer_typelist: []
            }
        },
        watch: {
            'selectList.marginAmount'(selectValue) {
                console.log(selectValue, "aaaaaaaaa", Number(selectValue) * 0.005);
                if (Number(selectValue) * 0.005 < 400) {
                    this.selectList.premium = 400.00
                } else {
                    this.selectList.premium = number_format(Number(selectValue) * 0.005, 2)
                }
            }
        },
        methods: {
            tishi() {
                this.$message({
                    title: "警示",
                    message: "本邮箱为接受保单的唯一途径，请务必确保信息准确无误",
                    type: "error",
                    offset: 900,
                    center: true
                });
            },
            biaoshu() {
                this.$message({
                    title: "提示",
                    message: "标书有效天数必须填写数字",
                    type: "error",
                    offset: 900,
                    center: true
                });
            },
            nowtoubao() {
                this.$refs.selectList.validate((valid) => {
                    if (!valid) {
                        this.$message({
                            title: "提示",
                            message: "请检查是否填写完整",
                            type: "error",
                            offset: 900,
                            center: true
                        });
                    } else {
                        var listjson = {
                            tenProjCode: this.selectList.tenProjCode,
                            bidder: this.selectList.bidder,
                        }
                        var jsonstr = JSON.stringify(listjson);
                        var checkjson = Base64.encode(jsonstr);
                        console.log(jsonstr, checkjson, "2")
                        post('/orderData/check', checkjson).then(res => {
                            if (res.status == 'success') {
                                if (res.exist) {
                                    this.$message({
                                        title: "提示",
                                        message: "您的项目已投保，不可重复投保",
                                        type: "error",
                                        offset: 900,
                                        center: true
                                    });
                                } else if (!res.exist) {
                                    var jsonstrn = JSON.stringify(this.selectList);
                                    var json = Base64.encode(jsonstrn);
                                    console.log(jsonstrn, json, "8")
                                    post('/orderData/accept', json).then(res => {
                                        if (res.status == 'success') {
                                            this.$message({
                                                message: "已成功采集到您的投保信息,即将跳转至付款指引页面",
                                                type: "success",
                                                offset: 900,
                                                center: true
                                            });
                                            setTimeout(() => {
                                                this.selectList.id = res.message;
                                                this.$router.push({ path: '/paymentguide', query: this.selectList })
                                            }, 3000);
                                        } else {
                                            this.$message({
                                                title: "提示",
                                                message: "提交失败，稍后重试",
                                                type: "error",
                                                offset: 900,
                                                center: true
                                            });
                                        }
                                    })
                                }
                            } else if (res.status == 'fail') {
                                this.$message({
                                    title: "提示",
                                    message: "信息查询失败，我们无法确认您的订单他人是否重复投保，请您稍后投保",
                                    type: "error",
                                    offset: 900,
                                    center: true
                                });
                            }

                        })

                    }
                })
            }
        }
    }
</script>
<style>
    .el-picker-panel .el-picker-panel__content {
        width: 95% !important;
    }

    .el-message--error .el-message__content {
        font-size: 2rem !important;
    }

    .el-message--success .el-message__content {
        font-size: 2rem !important;
    }

    .el-message {
        min-width: 380px;
        width: 35rem !important;
        height: 6rem !important;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-width: 1px;
        border-style: solid;
        border-color: #EBEEF5;
        position: fixed;
        left: 50%;
        top: 20px;
        /* text-align: center; */
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        background-color: #edf2fc;
        -webkit-transition: opacity .3s, top .4s, -webkit-transform .4s;
        transition: opacity .3s, top .4s, -webkit-transform .4s;
        transition: opacity .3s, transform .4s, top .4s;
        transition: opacity .3s, transform .4s, top .4s, -webkit-transform .4s;
        padding: 15px 15px 15px 20px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }

    .el-message--error {
        background-color: rgb(254, 240, 240) !important;
        border-color: rgb(253, 226, 226) !important;
    }

    .el-form-item__error {
        color: #F56C6C;
        font-size: 2rem !important;
        line-height: 1;
        padding-top: 4px;
        position: absolute;
        top: 100%;
        left: 0;
    }

    .el-row {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        margin: 2rem !important;
    }
</style>
<style scoped>
    #nav {
        width: 100%;
        margin: 0 auto;
    }

    #nav .bgc {
        background: url(~@/assets/headertow.png) no-repeat;
        background-size: 100%;
        width: 100%;
        height: 590px;
        position: relative;
    }

    .row {
        width: 100%;
        margin: 0 0 100px 0;
    }

    .width_100 {
        width: 100%;
        font-size: 2rem;
    }

    /deep/.el-form-item__label {
        text-align: right;
        vertical-align: middle;
        float: left;
        font-size: 2rem;
        color: #606266;
        line-height: 2rem;
        padding: 2rem 1rem 0 0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    /deep/.el-input {
        position: relative;
        font-size: 2rem;
        display: inline-block;
        width: 100%;
    }

    /deep/.el-input__inner {
        -webkit-appearance: none;
        background-color: #FFF;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 5rem;
        line-height: 5rem;
        outline: 0;
        padding: 0 2rem;
        -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
        transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
        width: 100%;
    }

    /deep/.el-select-dropdown__empty {
        padding: 10px 0;
        margin: 0;
        text-align: center;
        color: #999;
        font-size: 2rem;
    }

    .footer-mian-fixed {
        width: 100%;
        height: 100px;
        position: fixed;
        bottom: 0;
        background-color: #fff;
        z-index: 20;
        display: flex;
    }

    .footer-mian-fixed .left {
        width: 70%;
        height: 100%;
        color: #999999;
        font-size: 2rem;
        margin-left: 2rem;
    }

    .footer-mian-fixed .left span {
        height: 100%;
        color: #EE7800;
        font-size: 2rem;
        display: inline-block;
        text-align: center;
        line-height: 100px;

    }

    .footer-mian-fixed .right {
        width: 30%;
        background-color: #ee7800;
        font-size: 40px;
        line-height: 100px;
        text-align: center;
        color: #fff;
    }

    /deep/.el-input__icon {
        height: 100%;
        width: 25px;
        text-align: center;
        -webkit-transition: all .3s;
        transition: all .3s;
        line-height: 5rem;
        padding: 2rem;
        display: none;
    }

    .footer-mian-fixed .right span {
        display: inline-block;
        width: 100%;
    }

    .footer-mian-fixed .right span a {
        display: inline-block;
        width: 100%;
    }
</style>